import * as types from './sortingModel.actionTypes';

const initialState = {
  // API state
  isLoading: false,
  isFetching: false,
  isLoadingMore: false,
  error: null,
  
  // Sorting model data
  weightages: {
    beds: 5,
    discharges: 5,
    revenue: 5,
    rating: 5
  },
  
  // Results from API
  rankings: [],
  totalHospitalsRanked: 0,
  sampleRankings: [],
  weightagesUsed: null,
  
  // Pagination data
  count: 0,
  totalCount: 0,
  page: 1,
  perPage: 100,
  totalPages: 0,
  
  // UI state
  isVisible: false,
  
  // Success state
  isSuccess: false
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_SORTING_MODEL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        isSuccess: false
      };

    case types.CREATE_SORTING_MODEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        isSuccess: true,
        totalHospitalsRanked: action.payload.total_hospitals_ranked,
        rankings: action.payload.data || [], // Store hospital data as rankings
        weightagesUsed: action.payload.weightages_used,
        // Pagination data
        count: action.payload.count || 0,
        totalCount: action.payload.total_count || 0,
        page: action.payload.page || 1,
        perPage: action.payload.per_page || 100,
        totalPages: action.payload.total_pages || 0
      };

    case types.CREATE_SORTING_MODEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        isSuccess: false
      };

    case types.SET_SORTING_MODEL_WEIGHTAGES:
      return {
        ...state,
        weightages: {
          ...state.weightages,
          ...action.payload
        }
      };

    case types.RESET_SORTING_MODEL:
      return {
        ...initialState,
        isVisible: state.isVisible // Preserve visibility state
      };

    case types.SET_SORTING_MODEL_VISIBILITY:
      return {
        ...state,
        isVisible: action.payload
      };

    // GET results
    case types.FETCH_SORTING_RESULTS_REQUEST:
        return {
          ...state,
          isFetching: true,
          error: null,
          isSuccess: false,
          rankings: [],
          count: 0,
          totalCount: 0,
          page: 1,
          totalPages: 0,
        };
    case types.FETCH_SORTING_RESULTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        isSuccess: true,
        rankings: action.payload.data || [],
        count: action.payload.count || 0,
        totalCount: action.payload.total_count || 0,
        page: action.payload.page || 1,
        perPage: action.payload.per_page || 100,
        totalPages: action.payload.total_pages || 0
      };
    case types.FETCH_SORTING_RESULTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
        isSuccess: false
      };

    case types.LOAD_MORE_SORTING_RESULTS_REQUEST:
      return {
        ...state,
        isLoadingMore: true,
        error: null
      };
    case types.LOAD_MORE_SORTING_RESULTS_SUCCESS:
      return {
        ...state,
        isLoadingMore: false,
        error: null,
        rankings: [...state.rankings, ...(action.payload.data || [])],
        count: state.count + (action.payload.count || 0),
        page: action.payload.page || state.page,
        perPage: action.payload.per_page || state.perPage,
        totalPages: action.payload.total_pages || state.totalPages
      };
    case types.LOAD_MORE_SORTING_RESULTS_FAILURE:
      return {
        ...state,
        isLoadingMore: false,
        error: action.payload
      };

    default:
      return state;
  }
};
